import { Meeting } from "@vincer/types";

import { BaseApi } from "./baseApi";
import { supabase } from "./supabase";

class MeetingApi extends BaseApi<Meeting> {
  async getByUserUuid(userUuid: string): Promise<Meeting[]> {
    const { data, error } = await supabase
      .from("meeting")
      .select("*, mentor:mentor_uuid(uuid, vincer_base_user(name, email))")
      .eq("mentee_uuid", userUuid)
      .order("scheduled_time", { ascending: false });

    if (error) throw error;
    return data || [];
  }

  async getByIdPopulated(id: string): Promise<Meeting> {
    const { data, error } = await supabase
      .from("meeting")
      .select(
        "*, mentor:mentor_uuid(uuid, vincer_base_user(name, email)), mentee:mentee_uuid(uuid, vincer_base_user(name, email))"
      )
      .eq("uuid", id)
      .maybeSingle();
    if (error) throw error;
    return data;
  }
  async setInactive(id: string): Promise<Meeting> {
    return this.update(id, { active: false });
  }
  async getMeetings(
    userUuid: string,
    role: "mentee" | "mentor"
  ): Promise<Meeting[]> {
    // Get the mentor UUID from the mentor table
    const { data: mentorData, error: mentorError } = await supabase
      .from("mentor")
      .select("uuid")
      .eq("user_uuid", userUuid)
      .single();

    if (mentorError) throw mentorError;
    const mentorUuid = mentorData?.uuid;

    const { data, error } = await supabase
      .from("meeting")
      .select("*, mentee:mentee_uuid(uuid, vincer_base_user(name, email))")
      .eq(role === "mentee" ? "mentee_uuid" : "mentor_uuid", mentorUuid)
      .order("scheduled_time", { ascending: true });

    if (error) throw error;
    return data || [];
  }
}

export const meetingApi = new MeetingApi("meeting");
